import { useEffect, useState } from 'react';
import RastreioServices from '../services/rastreioServices';
import history from '../services/history';
import { toast } from 'react-toastify';
import { paises } from "../utils/paises";
import { siglasEstados } from "../utils/siglasEstados";
import mapBoxConfig from "../config/mapbox";
import axios from 'axios'

/**
 * @param {string} codigoRastreio 
 * @param {string} recaptchaKey 
 * @returns {{
 *  isLoading: boolean,
 *  rastreio: import("../services/rastreioServices").RastreioResponse & { coordenadasUltimaOcorrencia?: { latitude: number, longitude: number }, urlSiteTransportadora?: URL }
 * }}
 */
const useRastreio = (codigoRastreio, recaptchaKey) => {
    const [state, setState] = useState({
        isLoading: false,
        rastreio: undefined
    })

    useEffect(() => {
        async function getRatreio() {
            RastreioServices.getRastreio(codigoRastreio, recaptchaKey)
                .then(async (rastreioResponse) => {
                    const ultimaOcorrencia = rastreioResponse.ocorrencias.at(0)
                    const deveCarregarCoordenadas = !!ultimaOcorrencia?.origem
                    if (deveCarregarCoordenadas) {
                        try {
                            const localidade = ultimaOcorrencia.origem ?? ""
                            const cidade = localidade.slice(0, localidade.length - 5)
                            const estado = localidade.slice(localidade.length - 2, localidade.length)
                            const paisFormatado = paises[localidade.toLowerCase()] ? paises[localidade.toLowerCase()] : ultimaOcorrencia.origem
                            const buscaFormatada = localidade.includes('-') ? `${cidade} - ${siglasEstados[estado]}` : paisFormatado
                            const cidadePais = localidade.includes('-') ? 'city' : 'country'

                            const { mapBoxToken } = mapBoxConfig;
                            const coordenadas = (
                                await axios.get(`https://api.mapbox.com/geocoding/v5/mapbox.places/${buscaFormatada}.json?&type=${cidadePais}&access_token=${mapBoxToken}`)
                                    .then(async ({ data }) => ({
                                        latitude: data.features[0].center[1],
                                        longitude: data.features[0].center[0]
                                    })
                                    )
                            )
                            rastreioResponse.coordenadasUltimaOcorrencia = coordenadas;
                        }
                        catch (e) {
                            console.error("Problemas ao buscar as coordenadas da ultima ocorrência...", e)    
                        }
                    }

                    const linkRastreio = rastreioResponse.rastreios.at(0)?.linkRastreio
                    if ( linkRastreio ) {
                        const urlSiteTransportadora = new URL(linkRastreio);
                        urlSiteTransportadora.search = ''
                        urlSiteTransportadora.pathname = '/'
                        rastreioResponse.urlSiteTransportadora = urlSiteTransportadora
                    }

                    setState(prev => ({ ...prev, rastreio: rastreioResponse }))
                })
                .catch((e) => {
                    console.error(e)
                    setState({ isLoading: false })
                    if (window.location.pathname.includes('/correios')) {
                        history.push('/correios', codigoRastreio);
                    } else {
                        toast.error("Código de Rastreio não encontrado.");
                        history.push('/');
                    }
                });
        }
        getRatreio()
        // eslint-disable-next-line
    }, []);

    return state
}
export default useRastreio;
